/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/stable";
import "regenerator-runtime/runtime";

// Import jQuery and make it global
import $ from "jquery";
window.jQuery = $;
global.jQuery = $;
window.$ = $;
global.$ = $;

// Import Rails UJS
import Rails from "@rails/ujs";
window.Rails = Rails;
Rails.start();

// Import and expose legacy utilities first
import "legacy-utils";
import Cookies from "js.cookie.min";
window.Cookies = Cookies;

// Import legacy vendor libraries
import "bootstrap.bundle.min";
import "argon.min";
import "cocoon";
import "pell.min";
import "selectize.min";
import "jquery.maskMoney.min";
import "global";

import "@hotwired/turbo-rails";
import "file_system_object_uploader";
import "controllers";
import "chartkick/chart.js";
